import Footer from "./Footer"

const Disorder = () => {
  return (
    <div className="mt-[120px]"> 
        <div className='bg-[#F3F4F8] flex-wrap flex gap-5 mt-5'>
      <div className=' text-[20px] px-5 lg:w-1/2 md:w-1/2 w-2/2'>
        <h3>Sleep Apnea is a potentially serious disorder</h3>
        <h3>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga labore laboriosam voluptatem asperiores recusandae quidem unde vero aut, non nesciunt, repellat optio illum nulla expedita adipisci nemo corporis. Quia inventore ipsa molestiae repellendus officiis recusandae possimus necessitatibus eligendi adipisci, doloribus quos facilis alias nemo tempora facere. Neque voluptatibus adipisci sint.</h3>

      </div>
      <div className='lg:grid   md:grid hidden'>
      <img className="w-[250px] h-[300px] " src={require("../assets/Inspire Sleep Apnea Innovation - Obstructive Sleep Apnea Treatment.jpg")} alt=""  />

      </div>
    </div >
    <div className="mt-5">
      <Footer/>
    </div>
    </div>
  )
}

export default Disorder
